import type { AppEnvType } from '../app-env';

export interface ISlackVars {
  channelId: string;
}

export const slackVars: Record<AppEnvType, ISlackVars> = {
  local: {
    channelId: 'C0A73GLJEPL',
  },
  dev: {
    channelId: 'C0A7040FB2R',
  },
  stg: {
    channelId: 'C0A774Y1A3E',
  },
  prod: {
    channelId: 'C0A7GET44KT',
  },
};
